module.exports = __webpack_public_path__ + "img/ltkvideo-1x.59d728a.jpg";